import { normalizeTitle } from "../helper";
import MarketplaceLogo from "./MarketplaceLogo";

const AppIcon = ({ title, size = 80 }: { title: string; size?: number }) => {
  const logoSrc = MarketplaceLogo[normalizeTitle(title)];
  return logoSrc ? (
    <img
      src={logoSrc}
      alt={normalizeTitle(title)}
      height={size}
      loading="lazy"
    />
  ) : null;
};

export default AppIcon;
